import script from "./ModalMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalMenu.vue?vue&type=script&setup=true&lang=js"

import "./ModalMenu.vue?vue&type=style&index=0&id=7f426e8b&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f426e8b"]])

export default __exports__